'use client';
import { formatDate, getClassNames } from '@/utils/helpers';
import { Button, Label, Status } from '@yaradigitallabs/ahua-react';
import type React from 'react';

type CalculationCardForTableProps = {
  title: string;
  value: string | number;
  unit?: string;
  className?: string;
  priority?: number;
  description?: string;
  timestamp?: string;
  onDetail?: () => void;
};

const CalculationCardForTable: React.FC<CalculationCardForTableProps> = ({
  title,
  value,
  unit,
  priority,
  className,
  description,
  timestamp,
  onDetail,
}) => {
  const formattedValue = Number.isFinite(value as number)
    ? (value as number).toFixed(2)
    : value;
  return (
    <div
      className={getClassNames(
        'rounded py-3 pb-2 flex flex-col justify-start gap-2',
        className ? className : ''
      ).trim()}
    >
      <div className="px-4 pb-2 flex flex-row items-start gap-4 border-b border-gray-200">
        {priority !== undefined && priority > 1 && (
          <Status size="n">{priority}</Status>
        )}
        {priority === 1 && (
          <Status size="n" colorType="purple">
            Primary
          </Status>
        )}
        <div className="flex flex-col justify-start gap-1">
          <Label maxLineCount={1} size="l">
            {title}
          </Label>
          {description && (
            <span className="text-md text-gray-500 text-wrap line-clamp-2">
              {description}
            </span>
          )}
        </div>
      </div>
      {onDetail ? (
        <div className="px-4 flex justify-between gap-3">
          <div className="flex justify-start items-center gap-4">
            <div className="px-3 py-1 rounded-lg flex justify-between items-center gap-4 border border-dashed border-gray-300 bg-gray-100">
              <>
                {formattedValue && (
                  <span className="text-md font-semibold text-gray-900">
                    {formattedValue}
                  </span>
                )}
                {unit && <span className="text-sm text-gray-500">{unit}</span>}
              </>
            </div>
            {timestamp && (
              <span className="text-xs text-gray-500 font-normal flex gap-4">
                Last update:&nbsp;
                {formatDate(timestamp)}
              </span>
            )}
          </div>
          <div>
            <Button variant="ghost" size="xs" onClick={onDetail}>
              Details
            </Button>
          </div>
        </div>
      ) : (
        <div className="px-4 flex justify-start items-center gap-4">
          <div className="px-3 py-1 rounded-lg flex justify-between items-center gap-4 border border-dashed border-gray-300 bg-gray-100">
            <span className="text-md font-semibold text-gray-900">
              {formattedValue}
            </span>
            {unit && <span className="text-sm text-gray-500">{unit}</span>}
          </div>
          {timestamp && (
            <span className="text-xs text-gray-500">
              Last update: {formatDate(timestamp)}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default CalculationCardForTable;
